import React from 'react';
import NotificationCenter from '../../../components/notifications/NotificationCenter/NotificationCenter';

const ManageNotification = () => {
    return (
        <NotificationCenter />
    )
}

export default ManageNotification;